<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Home" chevronLeft>Retour à l'accueil</SportipsButton>

                    </div>
                    <div class="text-h5 font-weight-bold text-darkblue">
                        Bourse aux dossards de {{ mainStore.module.nom }}
                    </div>
                    <v-alert v-if="!has_bourse_dossards && !is_bourse_dossards_active" border="start" border-color="red"
                        density="compact">Il n'y a pas de bourse aux dossards pour cet
                        évènement</v-alert>
                    <v-alert v-if="has_bourse_dossards && !is_bourse_dossards_active" border="start" border-color="red"
                        density="compact">La bourse aux dossards n'est plus disponible</v-alert>
                    <div v-if="is_bourse_dossards_active">

                        <BourseDossardList v-if="bourse_dossard_mode == 'direct'"></BourseDossardList>

                    </div>

                    <!-- Liste des inscriptions -->




                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import BourseDossardList from "@/components/BourseDossards/BourseDossardsList.vue";


export default {
    components: { BourseDossardList },
    name: 'BourseDossardsView',
    computed: {
        ...mapStores(useMainStore),
        has_bourse_dossards() {
            return this.mainStore.module.has_bourse_dossards;
        },
        is_bourse_dossards_active() {
            return this.mainStore.module.bourse_dossards_is_active;
        },
        bourse_dossard_mode() {
            return this.mainStore.module.bourse_dossard_mode;
        }
    },

}
</script>

<style lang="scss" scoped></style>